export class ProxyUser {

  racf: string;
  employeeId: string;

  setProxyUser(racf: string) {
    this.racf = racf;
  }
}

